import { ExtensionType, VideoResource, BaseTexture, utils, extensions } from '@pixi/core';
import { checkDataUrl } from '../../../utils/checkDataUrl.mjs';
import { checkExtension } from '../../../utils/checkExtension.mjs';
import { LoaderParserPriority } from '../LoaderParser.mjs';
import { createTexture } from './utils/createTexture.mjs';

const validVideoExtensions = [".mp4", ".m4v", ".webm", ".ogv"];
const validVideoMIMEs = [
  "video/mp4",
  "video/webm",
  "video/ogg"
];
const loadVideo = {
  name: "loadVideo",
  extension: {
    type: ExtensionType.LoadParser,
    priority: LoaderParserPriority.High
  },
  config: {
    defaultAutoPlay: true
  },
  test(url) {
    return checkDataUrl(url, validVideoMIMEs) || checkExtension(url, validVideoExtensions);
  },
  async load(url, loadAsset, loader) {
    const options = {
      autoPlay: this.config.defaultAutoPlay,
      ...loadAsset?.data?.resourceOptions
    };
    const src = new VideoResource(url, options);
    await src.load();
    const base = new BaseTexture(src, {
      alphaMode: await utils.detectVideoAlphaMode(),
      resolution: utils.getResolutionOfUrl(url),
      ...loadAsset?.data
    });
    base.resource.src = url;
    const texture = createTexture(base, loader, url);
    return texture;
  },
  unload(texture) {
    texture.destroy(true);
  }
};
extensions.add(loadVideo);

export { loadVideo };
//# sourceMappingURL=loadVideo.mjs.map
